
const decodeUrl=(url=window.location.href)=>{
    
  // Example: Decode the parameters from the URL
  var decodedParams = {};
  
  // Extract the parameter part from the URL
  var paramIndex = url.indexOf('?');
  if (paramIndex !== -1) {
    var paramString = url.substring(paramIndex + 1);
  
    // Split parameters and decode each key-value pair
    var pairs = paramString.split('&');
    pairs.forEach(pair => {
      var [key, value] = pair.split('=');
  
      // Special handling for apnlist parameter
    //   if (key === 'apnlist') {
        decodedParams[key] = JSON.parse(decodeURIComponent(value));
    //   } else {
    //     decodedParams[key] = decodeURIComponent(value);
    //   }
    });
  }
  
  // Log the decoded parameters
  return decodedParams
  
  // Now you can access decodedParams.apnlist as an array, decodedParams.user, and decodedParams.count in your application
    }
export default decodeUrl